import React from 'react';
import { motion } from 'framer-motion';
const layers = [{
  letter: 'C',
  name: 'Contexto',
  desc: 'Sitúa a la IA en el escenario exacto de tu problema.'
}, {
  letter: 'R',
  name: 'Rol',
  desc: 'Asigna una identidad experta para elevar el nivel de respuesta.'
}, {
  letter: 'T',
  name: 'Tarea',
  desc: 'Define el objetivo específico sin ambigüedades.'
}, {
  letter: 'R',
  name: 'Restricción',
  desc: 'Establece límites claros para evitar alucinaciones y relleno.'
}];
export function MechanismSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-93">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-cyan-glow/5 blur-[100px] pointer-events-none" data-id="element-94" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-96">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-4" data-id="element-97">
            El Método{' '}
            <span className="text-cyan-glow text-glow tracking-widest" data-id="element-98">
              C-R-T-R
            </span>
          </h2>
          <p className="text-xl text-cyan-accent font-semibold tracking-wide uppercase mb-8" data-id="element-99">
            Contexto - Rol - Tarea - Restricción
          </p>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-100">
            Este sistema no se basa en palabras mágicas, sino en la arquitectura
            del lenguaje. Al estructurar tu orden en 4 capas lógicas, obligas a
            la IA a ignorar el ruido de internet y enfocarse únicamente en tu
            objetivo.
          </p>
          <p className="mt-4 text-lg text-white font-medium italic max-w-3xl mx-auto" data-id="element-101">
            "Es la diferencia entre preguntarle a un desconocido en la calle o
            darle una orden directa a un Consultor Senior con 20 años de
            experiencia."
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 relative" data-id="element-102">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-cyan-accent/30 to-transparent -translate-y-1/2 z-0" data-id="element-103" />

          {layers.map((layer, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="glass-card rounded-2xl p-8 text-center relative z-10 group hover:-translate-y-2 transition-transform duration-300" data-id="element-104">
              <div className="w-20 h-20 mx-auto bg-navy-900 rounded-full border-2 border-cyan-accent/50 flex items-center justify-center mb-6 group-hover:border-cyan-glow group-hover:shadow-[0_0_20px_rgba(0,229,255,0.4)] transition-all" data-id="element-105">
                <span className="text-4xl font-black text-cyan-glow" data-id="element-106">
                  {layer.letter}
                </span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3" data-id="element-107">
                {layer.name}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-108">
                {layer.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}